export const getValidFiltersState = (formData) => {
  const data = Object.entries(formData).filter(([, value]) => value);
  return Object.fromEntries(data);
};
